const eventBus = window.theme.searchAutocomplete.eventBus

class SearchDropdown extends HTMLElement {
  constructor () {
    super()

    this.elements = {
      initialView: this.querySelector('[data-search-dropdown-el="initial-view"]'),
      searchedView: this.querySelector('[data-search-dropdown-el="searched-view"]'),
      searchedViewZero: this.querySelector('[data-search-dropdown-el="searched-view-zero-heading"]'),
      searchedViewAside: this.querySelector('[data-search-dropdown-el="searched-view-aside"]'),
      searchedViewList: this.querySelector('[data-search-dropdown-el="searched-view-list"]'),
      backdrop: this.dialog.querySelector('[data-search-dropdown-el="backdrop"]'),
    }

    this.externalElements = {
      wrapper: this.closest('[data-search-dropdown-external-el="wrapper"]'),
    }
  }

  connectedCallback () {
    this.attachEventListeners()
  }

  attachEventListeners () {
    eventBus.subscribe('searchAutoComplete:state:updated', this.render.bind(this))
    eventBus.subscribe('searchAutoComplete:ui:dropdown:open', this.handleDropdownOpen.bind(this))
    eventBus.subscribe('searchAutoComplete:ui:dropdown:close', this.handleDropdownClose.bind(this))

    this.elements.backdrop.addEventListener('click', this.handleDropdownClose.bind(this))

    if (window.matchMedia('(min-width: 750px)').matches) {
      document.addEventListener('click', this.handleDocumentClick.bind(this))
    }
  }

  handleDocumentClick (event) {
    const searchDropdown = this.externalElements.wrapper
    const searchInput = document.querySelector('search-input')

    if (!searchDropdown.contains(event.target) && !searchInput.contains(event.target)) {
      this.handleDropdownClose()
    }
  }

  render () {
    if (window.theme.searchAutocomplete.stateLayer.state.term === '') {
      this.elements.initialView.classList.remove('hidden')
      this.elements.searchedView.classList.add('hidden')
      return
    }

    this.elements.searchedViewZero.innerHTML = ''
    this.elements.searchedViewAside.innerHTML = ''
    this.elements.searchedViewList.innerHTML = ''

    const resultsCount = window.theme.searchAutocomplete.stateLayer.state.products.hits.length

    if (resultsCount > 0) {
      this.elements.initialView.classList.add('hidden')
      this.elements.searchedView.classList.remove('hidden')

      if (window.theme.searchAutocomplete.stateLayer.state.keywords) {
        this.elements.searchedViewAside.insertAdjacentHTML('beforeend', this.buildSuggestedKeywords())

        this.attachKeywordClickEvent()
      }

      this.elements.searchedViewList.insertAdjacentHTML('beforeend', this.buildResultsList())

      this.attachProductClickEvent()
    } else {
      this.elements.initialView.classList.remove('hidden')
      this.elements.searchedView.classList.add('hidden')

      this.elements.searchedViewZero.insertAdjacentHTML('beforeend', `No search results for '${window.theme.searchAutocomplete.stateLayer.state.term}'`)
    }
  }

  buildSuggestedKeywords () {
    const keywords = window.theme.searchAutocomplete.stateLayer.state.keywords.hits
    const searchTerm = window.theme.searchAutocomplete.stateLayer.state.term

    const html = `
      <div class="hd-SearchDropdown_Terms">
        <h3 class="hd-SearchDropdown_SubHeading">Search Suggestions</h3>
        <ul class="hd-SearchDropdown_TermList">
          ${keywords.map(i => {
            const highlightedKeyword = i.keyword.replace(
              new RegExp(`(${searchTerm})`, 'gi'),
              '<strong style="color: #000">$1</strong>',
            )
            return `
              <li class="hd-SearchDropdown_TermItem">
                <a href="/search/?q=${i.keyword}" data-search-dropdown-el="keyword" class="hd-SearchDropdown_TermLink" style="color: #8d8d8d">
                  ${highlightedKeyword}
                </a>
              </li>
            `
          }).join('')}
        </ul>
      </div>
    `
    return html
  }

  buildResultsList () {
    const products = window.theme.searchAutocomplete.stateLayer.state.products.hits

    const html = `
      <h3 class="hd-SearchDropdown_SubHeading">Product Matches</h3>
      <a href="/search/?q=${window.theme.searchAutocomplete.stateLayer.state.term}" data-search-dropdown-el="viewAll" class="hd-SearchDropdown_CollectionViewAll">View All</a>
      <ul class="hd-SearchDropdown_Grid">
        ${products.map(product => {
          const productWithRoot = {
            ...product,
            root: 'autocomplete',
          }

          const clone = document.importNode(this.templateProductCard.content, true)
          const productCard = clone.querySelector('product-card')
          productCard.setAttribute('data-prop-data', JSON.stringify(productWithRoot))

          // Create a temporary container to hold the product card HTML
          const tempContainer = document.createElement('div')
          tempContainer.appendChild(clone)

          return `
            <li class="hd-SearchDropdown_Item">
              ${tempContainer.querySelector('product-card').outerHTML}
            </li>
          `
        }).join('')}
      </ul>
    `
    return html
  }

  attachProductClickEvent () {
    this.querySelectorAll('[data-product-card-el="link"]').forEach(link => {
      link.addEventListener('click', (event) => {
        const productData = JSON.parse(event.currentTarget.closest('product-card').dataset.propData)

        if (window.Shopify.trackingConsent.analyticsProcessingAllowed()) {
          eventBus.publish('searchAutoComplete:tracking:product:clicked', {
            productId: productData.productId,
            url: productData.url,
          })
        }
      })
    })
  }

  attachKeywordClickEvent () {
    this.querySelectorAll('[data-search-dropdown-el="keyword"]').forEach(link => {
      link.addEventListener('click', this.handleKeywordClick.bind(this))
    })
  }

  handleKeywordClick (event) {
    const term = event.currentTarget.textContent.replace(/\n/g, '').trim()

    const searchRequest = {
      query: term,
      products: {
        fields: ['name', 'imageUrl', 'price', 'listPrice', 'url', 'skus.name', 'skus.id', 'skus.inventoryLevel'],
      },
      keywords: {
        fields: ['keyword'],
        size: 5,
      },
    }

    const keywordData = {
      keyword: term,
      searchRequest,
    }

    if (Shopify.trackingConsent.analyticsProcessingAllowed()) {
      sessionStorage.setItem('autocompleteKeyword', JSON.stringify(keywordData))
    }
  }

  handleDropdownOpen () {
    this.dialog.show()
    document.body.style.overflow = 'hidden'
  }

  handleDropdownClose () {
    this.dialog.close()
    this.dialog.removeAttribute('open')
    document.body.style.overflow = 'visible'
  }

  handleKeyDown (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      this.handleDropdownClose()
    }
  }

  get dialog () {
    return this.closest('dialog')
  }

  get templateProductCard () {
    return document.getElementById('templateProductCard')
  }
}

customElements.define('search-dropdown', SearchDropdown)
